






















































































































































































































































































































import Vue from "vue";
import HeadPlanet from "../components/HeadPlanet.vue";
import SkillStaments from "../components/SkillStaments.vue";
import Navigation from "../components/Navigation.vue";
import BurguerMenu from "../components/BurguerMenu.vue";
import WIP from "../components/WIP.vue";
import "../css-modules/flex-helpers.scss";
import "../css-modules/containers.scss";
import "../css-modules/fonts.scss";
import "../css-modules/variables.scss";
import InteractionState from "@/Globals/InteractionState";
import { mapState } from "vuex";

export default Vue.extend({
  components: {
    HeadPlanet,
    Navigation,
    SkillStaments,
    BurguerMenu,
    WIP
  },
  data: function() {
    return {
      skill: "code",
      canvasContainer: null,
      showMenu: true
    };
  },
  computed: mapState(["currentState"]),
  watch: {
    currentState(newVal, oldVal) {
      if (oldVal === InteractionState.Root && newVal != InteractionState.Root) {
        this.$data.showMenu = false;
      } else if (newVal === InteractionState.Root) {
        this.$data.showMenu = true;
      }
    }
  },
  methods: {
    goToRoot() {
      this.$store.commit("changeState", InteractionState.Root);
    }
  },
  mounted() {
    window.requestAnimationFrame(() => {
      this.$data.canvasContainer = this.$refs.canvasContainer;
    });
  }
});
